import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "px-5 pt-6 pb-4 flex flex-col flex-1 min-h-0",
    "data-testid": "tax-receipts-placeholder-view"
};
const _hoisted_2 = { class: "w-full" };
import TaxReceiptsPageHeader from "../components/tax-receipts/TaxReceiptsPageHeader.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TaxReceiptsPlaceholderView',
    setup(__props) {
        // Screens of the tax-receipts area not delivered yet: the header and its tabs only, no content.
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(TaxReceiptsPageHeader)
                ])
            ]));
        };
    }
});
